module.exports = __webpack_public_path__ + "80c1921f6ef3de0a74bc753ab01903b5.pdf";